import GoogleButton from './googleButton.vue'
export default GoogleButton
